<template>
	<header class="sticky top-0 z-20 flex h-16 items-center gap-4 border-b border-slate-200 bg-white px-5">
		<button type="button" class="btn-ghost -ml-2 px-2" aria-label="Toggle menu" @click="$emit('toggle')">
			<PanelsTopLeft class="h-5 w-5" />
		</button>

		<label class="relative w-full max-w-md">
			<Search class="pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
			<input
				v-model="query"
				type="search"
				placeholder="Search tours, suppliers, customers, bookings..."
				class="w-full rounded-full border border-slate-200 bg-slate-50 py-2.5 pl-10 pr-4 text-sm text-slate-600 placeholder:text-slate-400 focus:border-brand-300 focus:bg-white focus:outline-none focus:ring-2 focus:ring-brand-100"
				@keyup.enter="search"
			/>
		</label>

		<div class="ml-auto flex items-center gap-1.5">
			<span
				v-if="!connection.online"
				class="mr-1 hidden items-center gap-1.5 rounded-full bg-amber-50 px-3 py-1 text-xs font-medium text-amber-700 sm:inline-flex"
				:title="connection.lastError || 'Trip Planner is not reachable'"
			>
				<CircleAlert class="h-3.5 w-3.5" />
				Sample data
			</span>

			<button type="button" class="btn-ghost relative px-2" aria-label="Notifications">
				<Bell class="h-5 w-5" />
				<span
					class="absolute right-1 top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-rose-500 px-1 text-[10px] font-semibold text-white"
					>1</span
				>
			</button>

			<button type="button" class="btn-ghost px-2" aria-label="Help">
				<CircleHelp class="h-5 w-5" />
			</button>

			<div class="ml-2 flex items-center gap-2.5 border-l border-slate-200 pl-3">
				<span
					class="flex h-9 w-9 items-center justify-center rounded-full bg-brand-100 text-sm font-semibold text-brand-700"
					>{{ initials(session.fullName) }}</span
				>
				<div class="hidden leading-tight sm:block">
					<p class="text-sm font-semibold text-slate-800">{{ session.fullName }}</p>
					<p class="text-xs text-slate-400">{{ session.role }}</p>
				</div>
				<button type="button" class="btn-ghost px-2 text-xs" @click="signOut">Log out</button>
			</div>
		</div>
	</header>
</template>

<script setup>
import { Bell, CircleAlert, CircleHelp, PanelsTopLeft, Search } from "lucide-vue-next";
import { ref } from "vue";
import { useRouter } from "vue-router";

import { connection } from "../api";
import { initials, logout, session } from "../api/session";
import { resetMenus } from "../utils/menuStore";

defineEmits(["toggle"]);

const router = useRouter();
const query = ref("");

function search() {
	if (!query.value.trim()) return;
	router.push({ path: "/bookings", query: { q: query.value.trim() } });
}

async function signOut() {
	await logout();
	resetMenus();
	router.push("/login");
}
</script>
